import "./App.css";
import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import AllRoutes from "./Routes/AllRoutes";
import usePageTracking from "./Component/usePageTracking";
import { useTranslation } from "react-i18next";

function App() {
  const { ready } = useTranslation();

  useEffect(() => {
    if (ready) {
      window.scrollTo({ behavior: "instant", top: 0 });
    }
  }, [ready]);

  usePageTracking();

  if (!ready) {
    return null;
  }

  return <AllRoutes />;
}

export default App;
